import BaseFilter from './filters/baseFilter';

export default function sectionToggler() {
    const sections = document.querySelectorAll('[data-section-toggler]');
    if (sections)
        sections.forEach(section => new BaseFilter(section, document));
}
